var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 96C168 125.833 149.856 151.429 124 162.353C110.634 168 106 171 102 179C101.611 179.779 101.278 180.52 100.969 181.208C99.6915 184.055 98.8184 186 96 186C93.1816 186 92.3085 184.055 91.0311 181.208C90.7221 180.52 90.3895 179.779 90 179C86 171 81 168 68 162.353C42.1445 151.429 24 125.833 24 96C24 56.2355 56.2355 24 96 24C135.765 24 168 56.2355 168 96ZM136 96.0001C136 118.091 118.091 136 96.0001 136C73.9087 136 56 118.091 56 96.0001C56 73.9087 73.9087 56 96.0001 56C118.091 56 136 73.9087 136 96.0001Z",
    fill: "#FF8800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a168cf7d818ee8de6a631e3e8b7ee367.svg";
export { ForwardRef as ReactComponent };